import Joi from "joi";

export const evaluationCriteriaSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
});
